<template>
  <div class="card shadow" >
    <div class="card-header border-0" >
      <div class="row align-items-center">
        <div class="col-md-3">
          <h3 class="mb-0">
            License Expiration
          </h3>
        </div>
        <div class="col-md-9 text-right">
              <base-button class="float-right ml-1" type="primary" size="sm"
              @click.prevent="showActionDrawer('export_list')">Export</base-button>
        </div>
      </div>
    </div>
    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
      <div v-if="profileAction == 'export_list'">
        <h6 class="heading-small text-muted mb-4">Export Options</h6> 
        <div>
          <a-radio-group v-model="filterStatus">
            <a-radio :style="radioStyle" :value="0">Export All Terminals</a-radio>
            <a-radio :style="radioStyle" :value="2">Export Filtered</a-radio>
          </a-radio-group>
        </div>

        <div style="
            position: absolute;
            bottom: 0px;
            right: 0px;
            width: -webkit-fill-available;
            background-color: #f2f2f2;
            padding: 10px;
          ">
          <button type="button" class="btn btn-primary float-right" @click.prevent="download">
            Export
          </button>
        </div>
      </div>
    </a-drawer>
    <div class="table-responsive">
      <vuetable
        v-if="apiURL"
        ref="vuetable"
        :api-url="apiURL"
        :http-options="httpOptions"
        :fields="fields"
        :sort-order="sortOrder"
        :show-sort-icons="true"
        :per-page="10"
        :css="css.table"
        pagination-path="pagination"
        data-path="data"
        no-data-template="Empty"
        @vuetable:load-error="onLoadError"
        @vuetable:pagination-data="onPaginationData"
      >
        
      </vuetable>
      <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from 'vuex';
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import HTTPRequest from '../../controllers/httpRequest.js';
import secureStorage from '../../controllers/secureStorage';


export default {
  name: 'license_expiration',
  props: {
    accountId: Number,
    selectedBucket: [String, Number],
     siteId: Number,
    type: {
      type: String
    },
    title: String
  },
  components: {
    Vuetable,
    VuetablePagination,
  },
  computed: {
    ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'profileId', 'parameters']),
  },
  data() {
    return {
      drawerVisible: false,
            accessRights: [],
            filterStatus: "",
            profileAction: "",
      componentKey: 0,
      apiURL: "",
      filterStatus: "",
      fields: [
        {name: "terminal_id", title: "Terminal ID"},
        {name: "terminal_name", title: "Terminal Name"},
        { name: "expiry_date", title: "Expiry Date", callback: "formatExpiryDate" },
        {name: "days_left", title: "Days Left"},
      ],
      httpOptions: {
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web"
        }
      },
      css: {
        table: {
          tableClass: 'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      }
    }
  },
  mounted: function () {
    this.reloadTable();
    let params = this.parameters
        ? `${this.parameters}&account_id=${this.accountId}&bucket=${this.selectedBucket}`
        : `?account_id=${this.accountId}&bucket=${this.selectedBucket}`;

    this.apiURL = `${this.endPoint}license_expiration/table${params}`;
  },
  watch: {
    accountId() {
      this.reloadTable();
    },
    selectedBucket() {
      this.reloadTable();
    },
    parameters() {
      this.reloadTable();
    }
  },
  methods: {
    ...mapActions(['updateCurrentProfile', 'updateParameters', 'updateProfileId']),
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async showActionDrawer(action) {
      this.profileAction = action;
      this.drawerVisible = true;
    },
    reloadTable() {
      const bucket = this.selectedBucket || '7';
      let params = this.parameters
        ? `${this.parameters}&account_id=${this.accountId}&bucket=${bucket}`
        : `?account_id=${this.accountId}&bucket=${bucket}`;

      this.apiURL = `${this.endPoint}license_expiration/table${params}`;
      this.$nextTick(() => {
        if (this.$refs.vuetable) {
          this.$refs.vuetable.refresh();
        }
      });
    },
    formatExpiryDate(value) {
      if (!value) return '';
      const date = new Date(value);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    download() {
        var payload = {};
        var additional_parameters = "";
        var baseUrl = this.endPoint + 'licenses' + "/download?file_type=csv&profile=license_expiration";
         payload["account_id"] = this.accountId;
        if (this.filterStatus == "0") {
          // All
          payload["type"] = "all";
           payload["bucket"] = '';
        }  else {
          // Filtered filterStatus == 2
          payload["type"] = "filtered";
          additional_parameters = this.parameters;
           
        payload["bucket"] = this.selectedBucket;
        }
      
        var exportFields = this.fields;
        var cbIndex = this.fields.indexOf("__checkbox");
        if (cbIndex > -1) exportFields.splice(cbIndex, 1);
        var actionIndex = this.fields.indexOf("__slot:actions");
        if (actionIndex > -1) exportFields.splice(actionIndex, 1);

        payload["fields"] = exportFields;
        additional_parameters = additional_parameters.replace("?", "&");

        axios({
          url: baseUrl + additional_parameters,
          method: "POST",
          responseType: "blob", // important
          headers: {
            Authorization: "Bearer " + secureStorage.getItem("accessToken"),
            "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"
          },
          data: payload,
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "license_expiration_notification.csv");
          document.body.appendChild(link);
          link.click();
          this.onClose();
          this.filterStatus = null;
          this.successMessage = "Download successful";
        });
    },
    refreshPage() {
      this.onClose()
      this.$refs.vuetable.refresh()
      this.successMessage = "Successful Operation"
      this.errorMessage = null
    },
    onClose() {
      this.errors = [];
      this.drawerVisible = false
      this.visible = false
      this.componentKey++
    },
  }
}
</script>
